import clsx from 'clsx'
import parse from 'html-react-parser'
import Link from 'next/link'
import React from 'react'

import s from './styles.module.scss'

import { IconSvg, NextImage } from '../../../../components/atoms'
import { ArticleCategoryEnum } from '../../../../lib/graphql'

type Article = {
  id: string
  pathname: string
  title: string
  date?: string
  thumbnail?: {
    src: string
    alt?: string
  }
  excerpt?: string
  categories?: ArticleCategoryEnum[]
}

interface IArticleProps {
  article: Article
  className?: string
  dataGtm?: string
}

export const ArticleThumbnail = ({
  article,
  className,
  dataGtm,
}: IArticleProps) => {
  return (
    <Link
      href={`/blog/${article.pathname}`}
      data-gtm={dataGtm}
      aria-label={article.title}
      className='group cursor-pointer focus:outline-none'
    >
      <article className={clsx(s.articleThumbnail, className)}>
        <div className={clsx(s.illustrationBlogPage)}>
          {article.thumbnail?.src ? (
            <NextImage
              src={article.thumbnail.src}
              alt={article.thumbnail.alt ?? ''}
              sizes='(max-width: 700px) 100vw, 50vw'
              className='scale-100 transition-transform duration-500 group-hover:scale-110'
            />
          ) : (
            <div className={s.emptyState}>
              <IconSvg.EmptyStateArticles style={{ opacity: '0.1' }} />
            </div>
          )}
        </div>
        <div className={s.content}>
          <h3 className='text-lg font-medium leading-tight group-focus:underline md:line-clamp-2 md:text-2xl'>
            {article.title}
          </h3>

          <div className='[&>p]:md:line-clamp-2'>
            {parse(article.excerpt ?? '')}
          </div>

          {article.date && (
            <p className='line-clamp-1 text-xs opacity-50'>
              {new Date(article.date).toLocaleDateString('fr')}
            </p>
          )}
        </div>
      </article>
    </Link>
  )
}
